/**
 * ErrorFallback Component
 * Displays the error modal when an error is caught by ErrorBoundary.
 * Uses hooks to access MessageModalContext.
 */

'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useMessageModal } from '@/contexts/layout';
import { Temper } from '@/types/frontend-types';

interface ErrorFallbackProps {
  onReset: () => void;
}

export function ErrorFallback({ onReset }: ErrorFallbackProps) {
  const router = useRouter();
  const { showMessageModal } = useMessageModal();

  useEffect(() => {
    // showMessageModal({
    //   temper: Temper.Bad,
    //   title: 'ERROR',
    //   hackerAllCaps: true,
    //   body: 'The CABAL is not yet ready',
    //   backButtonText: 'Acknowledge',
    //   disableDismiss: true,
    //   onBackClick: () => {
    //     onReset();
    //     router.push('/');
    //   },
    // });
  }, [showMessageModal, router, onReset]);

  // Render nothing - the modal is shown via context
  return null;
}

